import React from 'react';

import './style.scss';

const PagerLoadMore = ({ currentPage, totalPages, setCurrentPage, onLoadMore }) => {
  return (
    (totalPages > 1 && currentPage < (totalPages - 1)) ? (
      <div className="PagerLoadMore">
        <a
          className="PagerLoadMore__button PagerLoadMore__icon"
          onClick={(e) => {
            e.preventDefault();
            onLoadMore();
          }}>
          <span>Bekijk meer</span>
          <i className="icon-before icon-caret icon-variant-2" />
        </a>
      </div>
    ) : null
  );

};
export default PagerLoadMore;
